export const PATHS = {
  COMMAND_CENTER: 'emergencies',
  MONITORING: 'emergencies/monitoring',
  INCIDENT_DETAIL: 'emergencies/:incidentId',
  HISTORY: 'emergencies/history',
  TYPES: 'emergencies/types',
  CREATE_TYPE: 'emergencies/types/new',
  EDIT_TYPE: 'emergencies/types/:emergencyTypeId',
  INTEGRATIONS: 'emergencies/integrations',
  CREATE_INTEGRATION: 'emergencies/integrations/new',
  EDIT_INTEGRATION: 'emergencies/integrations/:integrationId',
} as const;

/** Route pattern of the organization shell every emergency route is mounted under. */
export const ORGANIZATION_BASE_PATH = '/:organizationId/-';

export const EMERGENCY_TIMELINE_TYPES = {
  LOCATION_SAMPLED: 'locationSampled',
  /** Operator messages; surfaced as the message thread in the detail panel. */
  NOTE_ADDED: 'noteAdded',
  EXTERNAL_CONTEXT_UPDATED: 'externalContextUpdated',
} as const;

/** Console container widths that switch queue / situation / map arrangement. */
export const EMERGENCY_CONSOLE_WIDE_MIN_PX = 1100;
export const EMERGENCY_CONSOLE_MEDIUM_MIN_PX = 700;

/**
 * How often the command centre recomputes elapsed timers and escalation
 * countdowns. One second: an operator watching a live panic incident needs the
 * clock to move, and a minute-resolution timer reads as a frozen screen.
 */
export const EMERGENCY_TICK_INTERVAL_MS = 1000;

/** Freshness thresholds, in minutes, shared by the list, map and detail views. */
export const EMERGENCY_FRESHNESS_WARNING_MINUTES = 5;
export const EMERGENCY_FRESHNESS_STALE_MINUTES = 10;

export const getEmergencyIncidentRoute = (incidentId: string): string =>
  `emergencies/${incidentId}`;

export const getEmergencyMonitoringRoute = (): string => PATHS.MONITORING;

export const getEmergencyTypeEditRoute = (emergencyTypeId: string): string =>
  `emergencies/types/${emergencyTypeId}`;
